export const drapcodeIconsRef = 'drapcode-icons';
